// @ts-strict-ignore
import { injectable, inject } from "tsyringe";
import { COOKIES } from "@identity/symbols";

@injectable()
export class PageViewNumberGenerator {
  constructor(@inject(COOKIES) private cookiesManager: CookiesManager) {}

  public getNextNumberFromCookie(cookieName: string): number {
    const currentNumber = parseInt(this.cookiesManager.get(cookieName));
    if (Number.isNaN(currentNumber)) {
      return 1;
    }

    return currentNumber + 1;
  }
}
